<div class="page-layout carded fullwidth left-sidebar">

    <!-- TOP BACKGROUND -->
    <div class="top-bg primary"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
          <button mat-icon-button class="mr-16" (click)="regresar()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          <h2 class="m-0">{{'EMAIL_HISTORY.TITLE' | translate}}- {{nameEmpresa}}</h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
            <!-- CONTENT TOOLBAR -->
            <div class="toolbar px-24 py-8">
                <span>{{'EMAIL_HISTORY.INST_GRAL' | translate}}</span>
            </div>
            <!-- / CONTENT TOOLBAR -->
            <div class="w100 p-20" fxFlex>
              <mat-sidenav-container class="h100">
                <mat-sidenav [mode]="'over'" [(opened)]="menuAbierto" class="w25">
                  <menu (cierraMenu)="menuAbierto = !menuAbierto; statusMenu.next({menu:menuAbierto,detalles:null})" (enviaProducto)="productoElegido.next($event)" class="m0p0"></menu>
                </mat-sidenav>
                <mat-sidenav-content class="white">
                  <contenido [statusMenu]="statusMenu.asObservable()" [productoElegido]="productoElegido.asObservable()" (abreMenu)="menuAbierto = !menuAbierto" (abreDetalles)="detallesAbierto = !detallesAbierto"></contenido>
                </mat-sidenav-content>
              </mat-sidenav-container>
            </div>
        </div>
        <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

</div>
